<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text
      ref="content"
      class="pt-5 height-min"
    >
      <v-row>
        <v-col cols="12">
          <span class="do-not-break">Hildegarde's Food Pantry</span>
          <v-spacer></v-spacer>
          <small class="do-not-break">{{ accountData.name }}</small>
        </v-col>
        <v-col cols="12">
          <img id="barcode" />
        </v-col>
      </v-row>
    </v-card-text>

    <!-- divider -->
    <v-divider></v-divider>

    <v-card-text>
      <v-btn
        color="primary"
        class="me-3 mt-3"
        @click="downloadPDF"
      >
        Print card
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { jsPDF } from 'jspdf'
import JsBarcode from 'jsbarcode'

export default {
  props: {
    accountData: {
      type: Object,
      required: true,
    },
    clientId: {
      type: String,
      required: true,
    },
  },

  setup() {
    return {}
  },

  mounted() {
    this.drawBarcode()
  },

  methods: {
    drawBarcode() {
      JsBarcode('#barcode', this.clientId, {
        width: 1.2,
        height: 60,
      })
    },

    downloadPDF() {
      const doc = new jsPDF({
        orientation: 'l', // landscape
        unit: 'pt', // points, pixels won't work properly
        // format: [243, 153] // set needed dimensions for any element
        format: [400, 200], // set needed dimensions for any element
      })

      doc.html(this.$refs.content.innerHTML, {
        callback: doc => {
          doc.save(`barcode-${this.clientId}.pdf`)
        },
        x: 10,
        y: 10,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.do-not-break {
    /** This fix the break word while printing the PDF */
    white-space: nowrap;
}
</style>
